import { createFileRoute } from "@tanstack/react-router";
import { AskPanel } from "@/components/ask/AskPanel";

/** The landing page: Agent Rocket, one chat across every product of the catalog. */
export const Route = createFileRoute("/_authenticated/agents/agent-rocket")({
  head: () => ({
    meta: [
      { title: "Agent Rocket · Oxley" },
      { name: "description", content: "Ask anything about your catalog and products in one conversation." },
      { property: "og:title", content: "Agent Rocket · Oxley" },
      { property: "og:description", content: "Ask anything about your catalog and products in one conversation." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <div className="mx-auto w-full"><AskPanel agentRocket /></div>,
});
